import { http, HttpResponse } from 'msw'

import { BASE_CONTRACTOR_API_DEV } from '@/constants/urls'

import { MOCK_ONBOARDING_STATE } from './contractorOnboarding.mocks'

export const contractorOnboardingHandlers = [
  http.get(`${BASE_CONTRACTOR_API_DEV}/v1/contractor-onboarding`, () => {
    return HttpResponse.json(MOCK_ONBOARDING_STATE)
  }),

  http.post(`${BASE_CONTRACTOR_API_DEV}/v1/contractor-onboarding/start`, () => {
    return HttpResponse.json(MOCK_ONBOARDING_STATE)
  }),

  http.post(
    `${BASE_CONTRACTOR_API_DEV}/v1/contractor-onboarding/personal-information`,
    async () => {
      return HttpResponse.json(MOCK_ONBOARDING_STATE)
    },
  ),

  http.post(
    `${BASE_CONTRACTOR_API_DEV}/v1/contractor-onboarding/payment-method`,
    async () => {
      return HttpResponse.json(MOCK_ONBOARDING_STATE)
    },
  ),

  http.post(
    `${BASE_CONTRACTOR_API_DEV}/v1/contractor-onboarding/complete`,
    () => {
      return HttpResponse.json(MOCK_ONBOARDING_STATE)
    },
  ),

  http.get(
    `${BASE_CONTRACTOR_API_DEV}/v1/my/displayable-tax-forms/:taxFormId`,
    () => {
      return HttpResponse.json({
        id: '366b210e-e96d-4cb3-a664-d1985261c952',
        state: 'UNSIGNED',
        type: 'W8BEN',
        base64pages: [''],
      })
    },
  ),

  http.post(`${BASE_CONTRACTOR_API_DEV}/v1/my/sign-tax-form`, () => {
    return HttpResponse.json({})
  }),
]
